<div id="app-loading">
  <div class="loader running"></div>
</div>
